function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("g", {
  fillRule: "nonzero",
  fill: "none"
}, /*#__PURE__*/React.createElement("path", {
  d: "M3.546 9.669l-.557 2.08-2.036.042A7.964 7.964 0 010 8a7.96 7.96 0 01.894-3.68l1.813.333.794 1.802a4.755 4.755 0 00.045 3.214z",
  fill: "#FBBB00"
}), /*#__PURE__*/React.createElement("path", {
  d: "M15.86 6.505a8.009 8.009 0 01-.035 3.165 7.998 7.998 0 01-2.817 4.569l-2.283-.117-.323-2.017a4.768 4.768 0 002.052-2.435H8.176V6.505H15.86z",
  fill: "#518EF8"
}), /*#__PURE__*/React.createElement("path", {
  d: "M13.008 14.238A7.966 7.966 0 018 16a7.999 7.999 0 01-7.047-4.209L3.546 9.67a4.757 4.757 0 006.856 2.436l2.606 2.133z",
  fill: "#28B446"
}), /*#__PURE__*/React.createElement("path", {
  d: "M13.106 1.842l-2.591 2.121A4.758 4.758 0 003.5 6.454L.895 4.322A7.998 7.998 0 018 0c1.941 0 3.72.691 5.106 1.842z",
  fill: "#F14336"
}));

function SvgGoogle(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref);
}

export default SvgGoogle;